import CardType from "../../logic/payment/CardType";
import { uuid } from "vue-uuid";

export default {
    mixins: [],
    data: () => ({
        deviceTransactionId: window?.transactionId || 'DEVICE_FINGERPRINTING_NOT_ENABLED'
    }),
    computed: {},
    watch: {},
    methods: {
        /**
         * The function "GetServices" retrieves items from a shopping cart and categorizes them as
         * either regular sales or hotel sales, and returns the data in a specific format.
         * @param Visitors - Visitors is a parameter that represents an array of visitors or guests who
         * will be participating in the activities or packages being purchased
         * @returns an object with a "Services" property that contains two properties: Activities and Packages
         */
        GetServices(Visitors) {
            let ActivitiesItems = [];
            let PackagesItems = [];
            // Obtenemos los items del carrito cuando sean para ventas regulares

            let Activities = Object.values(this.getShoppingCart)
                .filter((item) => item.type == 1 || item.type == 3)
                .map((item) => {
                    ActivitiesItems.push({
                        RateKey: item.RateKey,
                        Amount: item.Amount,
                        Visitors: [Visitors],
                    });
                });

            // Se usa cuando en una Reserva solo quieren comprar las fotos de Hotel
            // Asi que se vende el album como venta regular
            let ActivitiesOnlyHotel = Object.values(this.getShoppingCart)
                .filter(
                    (item) => (item.type === 2 || item.type === 0) && item.IsOnlyHotel
                )
                .map((item) => {
                    return item.Parks.map((park) => {
                        ActivitiesItems.push({
                            RateKey: park.RateKey,
                            Amount: park.Amount,
                            Visitors: [Visitors],
                        });
                    });
                });

            Activities = ActivitiesItems;

            // Obtenemos los items del carrito cuando sean para ventas Hotel
            let Packages = Object.values(this.getShoppingCart)
                .filter(
                    (item) => (item.type === 2 || item.type === 0) && !item.IsOnlyHotel
                )
                .map((item) => {
                    // Agregamos a cada paquete el nodo de visitor
                    item.sivexPayData.map((pack) => {
                        pack.Visitors = [Visitors];
                        // Agregamos los paquetes a la variable
                        PackagesItems.push(pack);

                        return pack;
                    });

                    return item.sivexPayData;
                });

            let DataActivities = { Activities: Activities };
            let DataPackages = { Packages: PackagesItems };

            return {
                Services: { ...DataActivities, ...DataPackages },
            };
        },
        /**
         * This function determines the type of credit card being used based on the first six digits of
         * the card number and assigns the corresponding bank ID if applicable.
         * @returns Bin card details
         */
        async CardType() {
            try {
                // Retiramos los espacios sobre la tarjeta y la preparamos
                let card = this.removeSpace(this.PaymentMethods.card);
                // Seteamos el nuevo valor sin espacios
                this.PaymentMethods.card = card;

                const cardLenght = card.length;
                const binNumber = card.substring(0, 6);
                if (cardLenght < 6) {
                    return;
                }

                // CARD VISA | MASTERCARD | AMEX
                this.CardInfo = await CardType.get(binNumber);
                this.PaymentMethods.bank = null;
                //Le asignamos el idBank a la propiedad del select del Banco, si estamos fuera de Monedas extranjeras
                if (this.$store.state.Currency === "MXN") {
                    this.PaymentMethods.bank = this.CardInfo.IdBank;
                }
            } catch (error) {
                console.error("failed to response the Bindb script", error);
            }
        },
        /**
         * The function `GetPayment` returns an object with payment information based on the selected
         * payment method and visitor information.
         * @param Visitors - It is a parameter that represents the buyer or visitor who is making the payment
         * @returns Returns an object.
         */
        async GetPayment(Visitors) {
            let Card = this.removeSpace(this.PaymentMethods.card);

            // PAYPAL
            if (this.PaymentMethod == 1) {
                return {
                    netCard: {
                        Buyer: Visitors,
                        Amount: this.$store.state.payment.Amount,
                        MSI: 1,
                        bankCharge: {
                            Id: 109,
                            Name: "OTROS",
                        },
                        cardType: {
                            Id: 9,
                            Name: "PayPal",
                        },
                        inauth: {
                            deviceTransactionId: this.deviceTransactionId,
                            returnURL: `${location}/${this.getLanguage}/carrito/netcard?method=PP`,
                            issuer: "",
                        },
                    },
                };
            }

            // OXXO
            if (this.PaymentMethod == 2 && this.CodeBankSafety == 15) {
                return {
                    netCard: {
                        Buyer: Visitors,
                        Amount: this.$store.state.payment.Amount,
                        MSI: 1,
                        bankCharge: {
                            Id: 109,
                            Name: "OTROS",
                        },
                        cardType: {
                            Id: 15,
                            Name: "OXXO",
                        },
                        inauth: {
                            returnURL: `${location}/${this.getLanguage}/carrito/details-payment/?details=POO`,
                            issuer: "",
                        },
                    },
                };
            }

            // SafetyPay(Walmart,  Super Farmacia Guadalajara,  Farmacias del Ahorro, Superama, etc..)
            if (this.PaymentMethod == 2 && this.CodeBankSafety != 15) {
                return {
                    netCard: {
                        Buyer: Visitors,
                        Amount: this.$store.state.payment.Amount,
                        MSI: 1,
                        bankCharge: {
                            Id: CodeBankSafety,
                            Name: "OTROS",
                        },
                        cardType: {
                            Id: 16,
                            Name: "SafetyPay",
                        },
                        inauth: {
                            returnURL: `${location}/${this.getLanguage}/carrito/details-payment/?details=POO`,
                            issuer: "",
                        },
                    },
                };
            }

            let cardsParameters = {
                CardNumber: Card,
                CVV: this.PaymentMethods.cvc,
                ExpireDate: {
                    Month: this.PaymentMethods.expireMonth,
                    Year: this.PaymentMethods.expireYear,
                },
                Buyer: Visitors,
                Amount: this.$store.state.payment.Amount,
                MSI: this.MSI,
                PaymentMethod: {
                    Id: parseInt(this.CardInfo.PaymentMethodCode) || 1,
                    Name: this.CardInfo.PaymentMethodName || "",
                },
                BankCharge: {
                    Id: parseInt(this.CardInfo.IdBank),
                    Name: this.CardInfo.Bank,
                },
            };

            // 1er Paso 3DS para enviar solo estos parametros
            if (this.isRequired3DS) {
                // cardsParameters.inauth.returnURL = this.$router.push({ name: 'challenge' })
                let baseUrl = window.location.origin;
                let url = this.$router.resolve({ name: "challenge" }).href;
                let inauth = { inauth: { returnURL: baseUrl + url } };

                cardsParameters = { ...inauth, ...cardsParameters };
            }

            // 2do Paso 3DS para enviar solo estos parametros
            if (this.requiredChallenge) {
                let cardsExtra = {
                    Challenge3DS: {
                        orderId: this.saleDetail.salesId.toString(),
                        merchant_Reference: this.saleDetail.invoiceId,
                        sessionId: this.challengeMD,
                    },
                };

                cardsParameters.CardNumber = this.saleDetail.cardNumber[0];

                cardsParameters = { ...cardsExtra, ...cardsParameters };
            }

            return {
                Cards: [cardsParameters],
            };
        },
        /**
         * This function handles the booking process for various payment methods and includes 3DS
         * validation and error handling.
         * @returns The function does not have a return statement. It may return undefined or a promise
         * depending on the execution path.
         * Type: 0 Card | 1 Paypal | 2 Convenience Store
         */
        async Booking() {
            try {
                if (this.currentStep === 2 || this.requiredChallenge) {
                    this.$store.dispatch("setLoading", true);
                    let formData = {};
                    const Visitors = {
                        FirstName: this.Buyer.FirstName,
                        LastName: this.Buyer.LastName,
                        FullName: this.Buyer.FullName,
                        Email: this.Buyer.Email,
                        Address: {
                            CountryId: this.Buyer.country,
                            StateId: this.Buyer.states,
                        },
                        Telephone: {
                            TelephoneClass: 1,
                            Number: this.Buyer.phone,
                        },
                        ClientType: 1,
                    };

                    let Services = this.GetServices(Visitors);

                    let arg = {
                        Required3DS: false,
                        Type: this.PaymentMethod,
                        CodeBankSafety: this.CodeBankSafety,
                        ShoppingCart: this.getShoppingCart,
                        PromotionCode: "",
                        Header: {
                            Channel: document.querySelector('meta[name="channel"]').getAttribute("content"),
                            ClientId: 0,
                            Currency: this.$store.state.Currency,
                            Language: this.getLanguage,
                            Country: "mex",
                            IP: window.ipAddress,
                            DeviceTransactionId: this.deviceTransactionId,
                            Browser: "SUF",
                        },
                        agent: {
                            agentId: document.querySelector('meta[name="agentId"]').getAttribute("content"),
                            name: "",
                            boxOffice: document.querySelector('meta[name="boxOffice"]').getAttribute("content"),
                        },
                        Payments: await this.GetPayment(Visitors),
                        Traveler: {
                            FirstName: this.Buyer.FirstName,
                            LastName: this.Buyer.LastName,
                            FullName: this.Buyer.FullName,
                            Email: this.Buyer.Email,
                            Address: {
                                CountryId: this.Buyer.country,
                                StateId: this.Buyer.states,
                            },
                            Telephone: {
                                TelephoneClass: 1,
                                Number: this.Buyer.phone,
                            },
                            ClientType: 1,
                        },
                        Analytics: {
                            ClientIdGa: "1667084626.1596297703",
                            UserIdGa:
                                "f709ecabfc4c6d6141412ee15f9aad96a21b9fb30250644ea5ea599be1d8d2b3",
                        },
                    };

                    /*3DS Paso 1 - Si la propiedad this.sessionId tiene valor, quiere decir que sera una primer peticion 
                    a Booking por que la tarjeta introducida requiere validacion 3DS*/
                    if (this.isRequired3DS) {
                        arg.Required3DS = true;
                        arg.Header.ddcsessionId = this.sessionId;
                    }

                    // 2do Paso 3DS para enviar solo estos parametros
                    if (this.requiredChallenge) {
                        arg.Header.tCookie = this.redirectDetails.cookie;
                        arg.reservation = {
                            salesId: this.saleDetail.salesId,
                            dsSalesId: this.saleDetail.invoiceId,
                        };
                    }

                    formData = { ...arg, ...Services };
                    formData.email = this.$store.state.email;

                    let response = await this.$store.dispatch("Booking", formData);
                    this.$store.dispatch("setLoading", false);

                    // Verificamos si la venta no pudo guardarse en la DB de Foto e intentaremos de nuevo
                    if (response?.save?.apiKoh) {
                      sessionStorage.setItem("apiKoh", JSON.stringify(response.save.apiKoh));
                    }

                    // CARD VISA | MASTERCARD | AMEX
                    if (this.PaymentMethod == 0) {
                        // 3DS step 1 - Validacion para detectar que la tarjeta no es un error si no que requiere validacion 3DS
                        if (this.isRequired3DS && response?.statusPayment !== 2 && response?.redirectDetails) {
                            return response;
                        }

                        // si regresa 1 sin redirectDetails es que rechazó de plano la tarjeta
                        if (this.isRequired3DS && response?.statusPayment === 1 && !response?.redirectDetails) {
                            Vue.$toast.open({
                                message: this.$t("messages.error_sale_made"),
                                type: "error",
                            });
                            
                            return;
                        }

                        if (this.isRequired3DS) {
                            return response;
                        }

                        // Validacion por si el pago no fue aprovado arrojamos el error general
                        if (response?.saleStatus != 7) {
                            Vue.$toast.open({
                                message: this.$t("messages.error_sale_made"),
                                type: "error",
                            });
                            
                            return;
                        }
                        // Simulate an HTTP redirect:
                        // Verificamos si hay alguna venta existente para no mostrar el codigo de descarga
                        let existingSaleShoppingCart = this.$store.getters.existingSaleShoppingCart;
                        let query = { dsSalesId: response.invoiceId };
                        // Verificamos si hay alguna venta existente para enviar valor en la URL
                        if (existingSaleShoppingCart) {
                            query.existingSale = true;
                        }

                        /* Adding the class hidden to the element with the id
                                                        modalPaypalSuccess. */
                        document.getElementById("modalPaypalSuccess").classList.remove("hidden");
                        // Limpiamos el Carrito si la venta fue success

                        // Redirigimos al usuario al detalle de su venta
                        setTimeout(() => {
                            this.$store.dispatch("clearShoppingCart");
                            this.$router.push({ name: "success_payment", params: query });
                        }, 5000);
                        return;
                    }

                    // PAYPAL
                    if (this.PaymentMethod == 1) {
                        return response;
                    }

                    // OXXO
                    if (this.PaymentMethod == 2 && this.CodeBankSafety == 15) {
                        window.location.replace(response.acsURL);
                    }

                    // SafetyPay
                    if (this.PaymentMethod == 2 && this.CodeBankSafety != 15) {
                        // Simulate an HTTP redirect:
                        this.$router.push({
                            name: "success_payment",
                            params: { dsSalesId: response.ReservationNumber },
                        });
                        return;
                    }
                }

                this.currentStep++;
            } catch (error) {
                this.$store.dispatch("setLoading", false);
                Vue.$toast.open({
                    message: this.$t("Forms.error_sale"),
                    type: "error",
                });
            }
        },
    }
};